const type = 'TOGGLE_ATTENDANCE_NOTES';

const toggleAttendanceNotes = () => ({
  type,
});

export default toggleAttendanceNotes;
